import type { JsonValue } from '../../mdr-ui-contracts/src/index.js';

export interface SurfaceOperationRoute {
  readonly method: string;
  readonly path: string;
  readonly mutability: 'read' | 'write';
  readonly idempotency: 'not-applicable' | 'optional' | 'required';
  readonly headerBindings?: readonly {
    readonly inputField: string;
    readonly headerName: string;
    readonly transform: 'integer-etag' | 'string';
    readonly required: boolean;
  }[];
}

function isJsonRecord(value: unknown): value is { readonly [key: string]: JsonValue } {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

export function operationRequest(
  route: SurfaceOperationRoute,
  input: JsonValue,
): {
  readonly path: string;
  readonly body?: string;
  readonly headers: Readonly<Record<string, string>>;
} {
  const values: Record<string, JsonValue> = isJsonRecord(input) ? { ...input } : {};
  const headers: Record<string, string> = {};
  for (const binding of route.headerBindings ?? []) {
    const value = values[binding.inputField];
    if (value === undefined || value === null || typeof value === 'object') {
      if (binding.required) {
        throw new Error(`操作缺少標頭參數：${binding.inputField}`);
      }
      continue;
    }
    headers[binding.headerName] = String(value);
    delete values[binding.inputField];
  }
  const pathWithParams = route.path.replace(/:([A-Za-z][A-Za-z0-9]*)/g, (_match, key) => {
    const value = values[key];
    if (typeof value !== 'string') throw new Error(`操作缺少路徑參數：${key}`);
    delete values[key];
    return encodeURIComponent(value);
  });
  if (route.method === 'GET') {
    const query = new URLSearchParams();
    for (const [key, value] of Object.entries(values)) {
      if (key === 'venueId' || value === null || value === undefined) continue;
      if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
        query.set(key, String(value));
      }
    }
    const suffix = query.toString();
    return {
      path: suffix ? `${pathWithParams}?${suffix}` : pathWithParams,
      headers,
    };
  }
  return {
    path: pathWithParams,
    body: JSON.stringify(isJsonRecord(input) ? values : input),
    headers,
  };
}
